'use client';
import { useCallback } from 'react';

declare global {
	interface Window {
		fbq?: (...args: any[]) => void;
	}
}

interface PixelRegisterEventData {
	accountId: string;
}
interface PixelDepositEventData {
	accountId: string;
	depositValue: number;
	currency: string;
}

const usePixelEvent = () => {
	const fireFacebookCompleteRegistration = useCallback(() => {
		if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
			console.log('Firing Facebook Complete Registration Pixel');
			return;
		}

		if (typeof window.fbq === 'function') {
			window.fbq('track', 'CompleteRegistration');
		}
	}, []);

	interface PurchaseData {
		value: string;
		currency: string;
	}

	const fireFacebookPurchase = useCallback((purchaseData: PurchaseData) => {
		if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT !== 'prod') {
			console.log('Firing Facebook Complete Registration Pixel');
			return;
		}

		if (typeof window.fbq === 'function') {
			window.fbq('track', 'Purchase', {
				value: purchaseData.value,
				currency: purchaseData.currency || 'USD',
			});
		}
	}, []);

	const fireRegistrationPixel = useCallback(
		({ accountId }: PixelRegisterEventData) => {
			(window as any).admCustomData = [
				{
					ACCOUNT_ID: accountId,
				},
			];

			const pixelId = 154765;
			const jsonUrl =
				'https://ps.l.liftdsp.com/ac0a7735-29ae-44a0-aed4-4bcc52fc3243.json';

			const script = document.createElement('script');
			script.innerHTML = `!function(a,e,d,m,t){
      a.adm={}; a.adm.pixid=${pixelId};
      var o=e.getElementsByTagName("head")[0], c=e.createElement("script");
      a.adm.json="${jsonUrl}";
      a.adm.pixurl="https://pool.admedo.com";
      c.src="https://pj.l.liftdsp.com/admtracker.lib.min.js";
      c.async=!0; o.appendChild(c);
    }(window,document);`;
			document.head.appendChild(script);

			const img = new Image();
			img.src = `https://pool.admedo.com/pixel?id=${pixelId}&t=img`;
		},
		[]
	);

	// Fire Deposit Pixel
	const fireDepositPixel = useCallback(
		({ accountId, depositValue, currency }: PixelDepositEventData) => {
			(window as any).admCustomData = [
				{
					ACCOUNT_ID: accountId,
					DEPOSIT_VALUE: depositValue.toString(),
					CURRENCY: currency,
				},
			];

			const pixelId = 154767;
			const jsonUrl =
				'https://ps.l.liftdsp.com/6f2f0d98-d94c-45bf-baec-0fde9c3a38d4.json';

			const script = document.createElement('script');
			script.innerHTML = `!function(a,e,d,m,t){
      a.adm={}; a.adm.pixid=${pixelId};
      var o=e.getElementsByTagName("head")[0], c=e.createElement("script");
      a.adm.json="${jsonUrl}";
      a.adm.pixurl="https://pool.admedo.com";
      c.src="https://pj.l.liftdsp.com/admtracker.lib.min.js";
      c.async=!0; o.appendChild(c);
    }(window,document);`;
			document.head.appendChild(script);

			const img = new Image();
			img.src = `https://pool.admedo.com/pixel?id=${pixelId}&t=img`;
		},
		[]
	);
	return {
		fireRegistrationPixel,
		fireDepositPixel,
		fireFacebookCompleteRegistration,
		fireFacebookPurchase,
	};
};

export default usePixelEvent;
